// extracted by css-extract-rspack-plugin
var _1 = "ky";
var _2 = "kw";
var _3 = "kx";
var _4 = "e1";
var _5 = "el";
var _6 = "f2";
export { _1 as "benefitDescription", _2 as "benefitItemComponent", _3 as "benefitTitle", _4 as "description", _5 as "image", _6 as "linkComponent" }
